import React from "react";
import PropTypes from "prop-types";
import Modal from "~components/Modal";

import "./style.scss";
import { WarningIcon } from "~misc/icons";

const CondicaoEspecialModal = ({ isOpen, handleConfirm, handleCancel, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      sub={<Content handleConfirm={handleConfirm} handleCancel={handleCancel} />}
      hideButtonOne={true}
      hideButtonTwo={true}
      onClose={onClose}
    />
  );
};

CondicaoEspecialModal.propTypes = {
  isOpen: PropTypes.bool,
  handleConfirm: PropTypes.func,
  handleCancel: PropTypes.func,
  onClose: PropTypes.func,
};

const Content = ({ handleConfirm, handleCancel }) => {
  return (
    <main className="prices-table-modal-condicao-especial">
      <div className="icon-container">
        <WarningIcon fill="red" className="icon" />
      </div>

      <p className="desc">A condição especial irá sobrepor a faixa já existente para o produto</p>
      <p className="desc">Deseja Continuar?</p>

      <div className="buttons-row">
        <button className="button cancel" onClick={handleCancel}>
          Não
        </button>
        <button className="button confirm" onClick={handleConfirm}>
          Sim
        </button>
      </div>
    </main>
  );
};

Content.propTypes = {
  handleConfirm: PropTypes.func,
  handleCancel: PropTypes.func,
};

export default CondicaoEspecialModal;
